import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  isDark: WritableSignal<boolean> = signal(false);

  constructor() {
    this.applyTheme()
  }

  setTheme(theme: string){
    localStorage.setItem('theme', theme);
    this.isDark.set(theme === 'dark' ? true : false);
    this.checkTheme();
  }

  applyTheme(){
    const storedTheme = localStorage.getItem('theme');

    switch (storedTheme) {
      case 'dark': this.isDark.set(true);
        break;

      case 'light': this.isDark.set(false);
        break;

      default:
        this.isDark.set(true);
        localStorage.setItem('theme', 'dark');
        break;
    }

    this.checkTheme();
  }

  checkTheme(){
    this.isDark()
    ? document.documentElement.classList.add('dark')
    : document.documentElement.classList.remove('dark')
  }

  toggleTheme(){
    this.isDark.update(el => !el);

    this.isDark()
    ? localStorage.setItem('theme', 'dark')
    : localStorage.setItem('theme', 'light');

    this.checkTheme();

  }
}
